import React, { useState, useRef } from 'react'; 
import "../Sponsors/Sponsors.css";

export default function Sponsors() {
  const sponsors = [
    { name: "SMART EDGE ECE REVIEW SPECIALIST", logo: "pics/sponsors/smartedge.png" },
    { name: "SUMITOMO ELECTRIC INDUSTRIES", logo: "pics/sponsors/sei.png" },
    { name: "SHAWARMA ALMALIK", logo: "pics/sponsors/shawarma.jpg" },
    { name: "SLIC3D", logo: "pics/sponsors/sliced.jpg" },
    { name: "MICROCADD", logo: "pics/sponsors/microcadd.png" },
  ];

  return (
    <div className="sponsors-container">
    <h1 className="sponsors-title">SPONSORS</h1>
      <section className="sponsors-section">
        <div className="sponsors-grid">
          {sponsors.map((sponsor, i) => (
            <div className="sponsor-card" key={i}>
              <img src={sponsor.logo} alt={sponsor.name} />
              <p>{sponsor.name}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );


}